import { render } from "./FooterRight.vue?vue&type=template&id=36ff1ac1&scoped=true"
import script from "./FooterRight.vue?vue&type=script&lang=js"
export * from "./FooterRight.vue?vue&type=script&lang=js"

import "./FooterRight.vue?vue&type=style&index=0&id=36ff1ac1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36ff1ac1"],['__file',"src/components/FooterRight.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "36ff1ac1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('36ff1ac1', __exports__)) {
    api.reload('36ff1ac1', __exports__)
  }
  
  module.hot.accept("./FooterRight.vue?vue&type=template&id=36ff1ac1&scoped=true", () => {
    api.rerender('36ff1ac1', render)
  })

}


export default __exports__